<template>


    <t-page-form-upload
        :type-image="typeImage"
        :command="command"
        :other-entity="otherEntity"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.occurrenceFileId" :foreign-key="form.occurrenceId"
        :items="items" :user-auth="userAuth" :status="status"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :categoryId="occurrenceFileType"
        :category-options="OccurrenceFileType.list"
        category-column="occurrenceFileType"
        :message-not-record="messageNotRecord"
        :only-view="onlyView"
        enable-public
        @onSubmit="onSubmit" @itemDownload="onItemFileDownload" @onItemDelete="onItemDeleteDefault"
        @onUploadComplete="onUploadComplete" @onRequestList="getList">

    </t-page-form-upload>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormUploadMixin from "@/mixins/page/pageFormUploadMixin";
import tPageFormUpload from "@/components/template/page/t-page-form-upload";
import OccurrenceFileType from "@/model/types/modules/checklist/OccurrenceFileType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormUploadMixin],
  components: {tPageFormUpload},
  name: 'OccurrenceFile',
  data() {
    return {
      OccurrenceFileType,
      path: "checklist/occurrence-file", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "occurrenceFileId",
      foreignKeyColumn: "occurrenceId", //Utilizar quando usar Tabs com outros componentes
      type: "D", //Tipo padrão de modelo de envio de arquivos poderá ser I ou D
      form: {
        occurrenceId: this.foreignKey,
        occurrenceFileId: 0,
        occurrenceFileType: 0,
        orderList: 0,
        type: "",
        subtitle: "",
        fileEntity: {
          nameOriginal: "",
          nameSave: "",
          sizeKb: 0,
          extension: "",
        }
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    otherEntity: Boolean,
    checklistId:{
      type: Number,
      default: 0,
    },
    occurrenceFileType: {
      type: Number,
      default: 0,
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      if (this.otherEntity) {
        this.command = 'view'
      }

      //Envia a origem do checklist
      if(this.checklistId > 0) {
        this.listParams.append("checklistId", this.checklistId.toString())
      }


      this.mountedPrepareFormUploadDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.occurrenceFileId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
